import { useEffect, useMemo } from 'react';
import { IWidgetContext } from '../../context/WidgetContext';
import { isNil } from 'ramda';

import gtag from '../../utils/gtag';
import useDHFlags from '../useDHFlags';

// https://www.simoahava.com/analytics/cookieflags-field-google-analytics/
const COOKIE_FLAGS = 'max-age=7200;secure;samesite=none';

const VERSION = 'v1';

const useSetupAnalytics = (widgetContext: IWidgetContext | null) => {
  const flags = useDHFlags();
  const version =
    flags.length !== 0
      ? `${VERSION}/${flags
          .filter(({ enabled }) => enabled)
          .map(({ name }) => name)
          .join('+')}`
      : VERSION;

  const defaultConfigOptions = useMemo(
    () => ({
      cookie_flags: COOKIE_FLAGS,
      anonymize_ip: true,
      send_page_view: false,
      accountId: widgetContext?.accountId,
      version,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [widgetContext],
  );

  useEffect(() => {
    if (widgetContext === null) return;

    gtag('config', process.env.NEXT_PUBLIC_GA_ID, defaultConfigOptions);

    if (!isNil(widgetContext.googleAnalytics4))
      gtag('config', `${widgetContext.googleAnalytics4}`, defaultConfigOptions);
  }, [defaultConfigOptions, widgetContext]);
};

export default useSetupAnalytics;
